import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider } from "@/context/MeContext";
import Layout from "@/components/Layout";
import { RequireAuth } from "@/components/common";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ListingDetail from "@/pages/ListingDetail";
import Publish from "@/pages/Publish";
import Messages from "@/pages/Messages";
import Checkout, { PaymentSuccess, PaymentCancel } from "@/pages/Checkout";
import Livraison, { DeliveryDetail } from "@/pages/Livraison";
import Debarras, { ClearanceDetail } from "@/pages/Debarras";
import Account from "@/pages/Account";
import { ProSpace, ProviderSpace } from "@/pages/Spaces";
import Admin from "@/pages/Admin";
import { PublicProfile, SignInPage, SignUpPage, Legal } from "@/pages/Misc";

const auth = (el, roles) => <RequireAuth roles={roles}>{el}</RequireAuth>;

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <MeProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/annonce/:id" element={<ListingDetail />} />
              <Route path="/profil/:id" element={<PublicProfile />} />
              <Route path="/publier" element={auth(<Publish />)} />
              <Route path="/publier/:id" element={auth(<Publish />)} />
              <Route path="/messages" element={auth(<Messages />)} />
              <Route path="/paiement/:listingId" element={auth(<Checkout />)} />
              <Route path="/paiement/succes" element={auth(<PaymentSuccess />)} />
              <Route path="/paiement/annule" element={auth(<PaymentCancel />)} />
              <Route path="/livraison" element={<Livraison />} />
              <Route path="/livraison/:id" element={auth(<DeliveryDetail />)} />
              <Route path="/debarras" element={<Debarras />} />
              <Route path="/debarras/:id" element={auth(<ClearanceDetail />)} />
              <Route path="/compte" element={auth(<Account />)} />
              <Route path="/pro" element={auth(<ProSpace />, ["pro", "admin"])} />
              <Route path="/prestataire" element={auth(<ProviderSpace />, ["provider", "admin"])} />
              <Route path="/admin" element={auth(<Admin />, ["admin"])} />
              <Route path="/legal/:page" element={<Legal />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" richColors />
        </MeProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
